(() => {
  const vendorMediaLink = document.querySelector(".js-vendor-banner__find-more");
  const brandMedia = document.querySelector(".js-brand-media");

  if (brandMedia == null) {
    vendorMediaLink.classList.add("hidden");
    return;
  }

  vendorMediaLink.addEventListener("click", (e) => {
    const stickyHeader = document.querySelector("sticky-header");
    const getHeight = stickyHeader.offsetHeight;
    const y = brandMedia.getBoundingClientRect().top + window.scrollY - getHeight;
    brandMedia.scrollIntoView({ offset: getHeight });
    window.scrollTo({ top: y, behavior: "smooth" });
  });
})();
